import React from 'react';
import VariantModel from '../../../../models/variantModel';
import { getProductsLanguages, getDefaultLanguage } from '../../utils/translationUtils';
import VariantsTable from './components/variantsTable';
import { convertMenhirToPyvarPipeTranslate } from '../../../../components/utils/pipeTranslateConvert';

export default function VariantList({ organization, productId }) {
    const [variants, setVariants] = React.useState([]);

    const productLanguages = React.useMemo(() => getProductsLanguages(organization), [organization]);
    const defaultLanguage = React.useMemo(() => getDefaultLanguage(organization, productLanguages), [organization, productLanguages]);

    // TODO : maybe refacto pipetranslate and initTranslations in utils files, they are also used in form product
    const getPipeTranslate = React.useCallback(
        string => {
            let translations = {};

            if (string.includes('|')) {
                string.split('|').forEach(item => {
                    let pipe = convertMenhirToPyvarPipeTranslate(item);
                    let regLang = pipe.slice(1, 6).toLowerCase();
                    pipe = pipe.slice(7, pipe.length);
                    if (productLanguages?.find(l => regLang === l)) translations[regLang] = pipe;
                });
            }
            return translations;
        },
        [productLanguages]
    );

    const initTranslations = React.useCallback(
        (obj, lang, fields) => {
            if (!obj.translations) obj.translations = {};
            fields?.forEach(field => {
                const pipeTranslate = getPipeTranslate(obj[field]);
                obj.translations[field] = { ...pipeTranslate, ...obj.translations[field] };
                //use name if no translations for default language
                if (obj.translations[field][lang]) obj[field] = obj.translations[field][lang];
                if (!obj.translations[field][lang]) obj.translations[field][lang] = obj[field];
                //we filter the languages keys that arent in organization
                Object.keys(obj.translations[field]).forEach(langKey => {
                    if (!productLanguages.some(ol => ol === langKey)) obj.translations[field][langKey] = '';
                });
            });
            return obj;
        },
        [productLanguages]
    );

    const [, loadingVariants, syncVariants] = VariantModel.useApiModel(
        {
            organizationId: organization.id,
            productId: productId,
            launch: Boolean(productId),
            query: {
                include: ['transaction_total_count']
            },
            onSuccess: response => {
                let objs = response;
                //we init the translations in case we don't have any
                objs = objs.map(obj => initTranslations(obj, defaultLanguage, ['name']));
                setVariants(objs);
            }
        },
        [productId, organization, defaultLanguage]
    );

    return (
        <VariantsTable
            organization={organization}
            productId={productId}
            loading={loadingVariants}
            variants={variants}
            syncVariants={syncVariants}
            setVariants={setVariants}
            productLanguages={productLanguages}
        />
    );
}
